export default {
  isShowWatermark: true,
  getWatermark() {
    return new Promise(function(resolve) {
      let user = {};
      try {
        user = JSON.parse(localStorage.vuex).userInfo;
      } catch (e) {}
      resolve(user);
    }).then(user => {
      return {
        name: "美菜网",
        id: user["name"]
      };
    });
  }
};
